import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [selected, setSelected] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelected(url);
      window.open(url, '_blank', 'noopener,noreferrer');
      setSelected('');
    }
  };

  return (
    <section className="w-full px-6 md:px-10 py-8 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <label className="block text-sm font-semibold text-foreground-700 mb-3 font-heading">
          Browse Product Categories
        </label>
        <div className="relative">
          <select
            value={selected}
            onChange={handleChange}
            className="w-full appearance-none bg-background-50 border border-background-300/60 rounded-xl px-5 py-4 text-sm text-foreground-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-300 transition-all"
          >
            <option value="" disabled>Select a category to explore on kaspreadsheet.com...</option>
            {categories.map((cat) => (
              <option key={cat.name} value={cat.url}>
                {cat.name}
              </option>
            ))}
          </select>
          <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-down-s-line text-foreground-500"></i>
          </div>
        </div>
        <p className="mt-2 text-xs text-foreground-500">
          Selecting a category will open the corresponding page on our main website in a new tab.
        </p>
      </div>
    </section>
  );
}